module.exports = __webpack_public_path__ + "img/pay-warn.46db4359.png";